import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../../config/api";
import "./seguimiento_financiero.css";

const SeguimientoFinanciero = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const { authFetch } = useAuth();

  const [datos, setDatos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editandoId, setEditandoId] = useState(null);

  const [valoresEditados, setValoresEditados] = useState({
    ingresos_reales: "",
    cg_mes: ""
  });

  const [guardando, setGuardando] = useState(false);

  // ==========================================
  // CARGAR SEGUIMIENTO FINANCIERO
  // ==========================================

  useEffect(() => {

    const cargarSeguimiento = async () => {

      try {

        setLoading(true);
        setError("");

        const url = `${ENDPOINTS.get_seguimiento_financiero}?id_informacion_general=${id}`;
        const data = await authFetch(url);

        if (!data.success) {

          throw new Error(data.message || "No fue posible cargar el seguimiento financiero.");

        }

        setDatos(data.data || []);

      } catch (err) {

        console.error("Error cargando seguimiento financiero:",err);
        setError(err.message || "Error al cargar el seguimiento financiero.");

      } finally {

        setLoading(false);

      }

    };

    if (id) {
      cargarSeguimiento();
    }

  }, [id, authFetch]);

  // ==========================================
  // FORMATEAR MONEDA
  // ==========================================
  const formatoMoneda = (valor) => {

      if (
          valor === null ||
          valor === undefined ||
          valor === ""
      ) {
          return "-";
      }

      const valorLimpio = String(valor).split(".")[0];

      return `$${valorLimpio.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  };

  // ==========================================
  // FORMATEAR MES
  // ==========================================

  const formatoMes = (fecha) => {

    if (!fecha) {
      return "-";
    }

    const partes = fecha.split("-");

    if (partes.length < 2) {
      return fecha;
    }

    const anio = partes[0];
    const mes = Number(partes[1]);

    const meses = [
      "",
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ];

    return `${meses[mes]} ${anio}`;

  };

  // ==========================================
// INICIAR EDICIÓN
// ==========================================

const iniciarEdicion = (item) => {

  setEditandoId(item.id);

  setValoresEditados({
    ingresos_reales: item.ingresos_reales_mes ?? 0,
    cg_mes: item.cg_mes ?? 0
  });

  setError("");
};

const cancelarEdicion = () => {

  setEditandoId(null);

  setValoresEditados({
    ingresos_reales: "",
    cg_mes: ""
  });

  setError("");
};

// ==========================================
// GUARDAR SEGUIMIENTO FINANCIERO
// ==========================================

const guardarEdicion = async (idSeguimiento) => {

  try {

    setGuardando(true);
    setError("");

    const ingresosReales = String(valoresEditados.ingresos_reales).trim();
    const cgMes = String(valoresEditados.cg_mes).trim();

    if (!/^\d+(\.\d{1,2})?$/.test(ingresosReales)) {
        throw new Error("Los ingresos reales deben ser un valor válido.");
    }

    if (!/^\d+(\.\d{1,2})?$/.test(cgMes)) {
        throw new Error("El valor de C&G debe ser un valor válido.");
    }

    const response = await authFetch(
      ENDPOINTS.update_seguimiento_financiero,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: idSeguimiento,
          ingresos_reales: ingresosReales,
          cg_mes: cgMes
        })
      }
    );

    if (!response.success) {

      throw new Error(
        response.message ||
        "No fue posible actualizar el seguimiento financiero."
      );

    }

    setEditandoId(null);

    setValoresEditados({
      ingresos_reales: "",
      cg_mes: ""
    });

    // ==========================================
    // VOLVER A CARGAR
    // ==========================================

    const url = `${ENDPOINTS.get_seguimiento_financiero}?id_informacion_general=${id}`;
    const data = await authFetch(url);

    if (!data.success) {

      throw new Error(data.message || "El registro se actualizó, pero no fue posible recargar la información.");

    }

    setDatos(data.data || []);

  } catch (err) {

    console.error("Error actualizando seguimiento financiero:",err);
    setError(err.message || "Error al actualizar el seguimiento financiero.");

  } finally {

    setGuardando(false);

  }

};

  // ==========================================
  // LOADING
  // ==========================================

  if (loading) {

    return (

      <div className="container mt-4">

        <h2>Seguimiento Financiero</h2>

        <div className="alert alert-info mt-3">
          Cargando información...
        </div>

      </div>

    );

  }

  // ==========================================
  // ERROR
  // ==========================================

  if (error) {

    return (

      <div className="container mt-4">

        <h2>Seguimiento Financiero</h2>

        <div className="alert alert-danger mt-3">
          {error}
        </div>

        <button className="btn btn-outline-pink" onClick={() => navigate(-1)}>
          <i className="bi bi-arrow-left me-2"></i>
          Volver
        </button>

      </div>

    );

  }

  // ==========================================
  // VISTA
  // ==========================================

  return (

    <div className="container-fluid mt-4">

      {/* ================================= */}
      {/* ENCABEZADO */}
      {/* ================================= */}

      <div className="d-flex justify-content-between align-items-center mb-4">

        <h2>Seguimiento Financiero</h2>

        <button className="btn btn-outline-pink" onClick={() => navigate(-1)}>
          <i className="bi bi-arrow-left me-2"></i>
          Volver
        </button>

      </div>

      {/* ================================= */}
      {/* SIN DATOS */}
      {/* ================================= */}

      {datos.length === 0 ? (

        <div className="alert alert-warning">

          Este contrato todavía no tiene
          desembolsos registrados en el
          seguimiento financiero.

        </div>

      ) : (

        <div className="card">

          <div className="card-header">
            <h5 className="mb-0">Desembolsos del contrato</h5>
          </div>

          <div className="card-body">

            <div className="seguimiento-financiero-scroll">

              <table className="table table-bordered table-hover align-middle seguimiento-financiero-table">

                {/* ENCABEZADO PRINCIPAL */}

                <thead>

                  {/* GRUPOS */}

                  <tr>

                    <th colSpan="3" className="text-center">Información del contrato</th>
                    <th colSpan="6" className="text-center">Ingresos</th>
                    <th colSpan="6" className="text-center">Costos y Gastos</th>
                    <th colSpan="2" className="text-center">Resultado</th>
                    <th colSpan="6" className="text-center">Administración</th>
                    <th colSpan="1" className="text-center">Acciones</th>

                  </tr>

                  {/* COLUMNAS */}

                  <tr className="table-light">

                    {/* INFORMACIÓN */}

                    <th>Programa</th>
                    <th>Contrato</th>
                    <th>Mes</th>

                    {/* INGRESOS */}

                    <th>Ppto Ingresos mes</th>
                    <th>Esperado mes</th>
                    <th>Ingresos reales mes</th>
                    <th>Ppto acum</th>
                    <th>Esperado acum</th>
                    <th>Ingresos acum.</th>

                    {/* C&G */}

                    <th>Ppto C&G mes</th>
                    <th>Esperado C&G mes</th>
                    <th>C&G mes</th>
                    <th>Ppto C&G acum</th>
                    <th>Esperado C&G acum</th>
                    <th>C&G acum.</th>

                    {/* RESULTADO */}

                    <th>Resultado mes</th>
                    <th>Resultado acumulado</th>

                    {/* ADMINISTRACIÓN */}

                    <th>Ppto Admón</th>
                    <th>Esperado Admón</th>
                    <th>Admón mes</th>
                    <th>Ppto Admón acum</th>
                    <th>Esperado Admón acum</th>
                    <th>Admón acum.</th>

                    {/* ACCIONES */}
                    <th>Acciones</th>

                  </tr>

                </thead>

                {/* ================================= */}
                {/* DATOS */}
                {/* ================================= */}

                <tbody>

                  {datos.map((item) => (

                    <tr key={item.id}>

                      {/* INFORMACIÓN */}

                      <td>{item.program_name || "-"}</td>
                      <td>{item.contrato_convenio || "-"}</td>
                      <td>{formatoMes(item.mes_año_ejecucion)}</td>

                      {/* INGRESOS */}

                      <td className="text-end">{formatoMoneda(item.ppto_ingresos_mes)}</td>
                      <td className="text-end">{formatoMoneda(item.esperado_ingresos_mes)}</td>
                      <td className="text-end">{editandoId === item.id ? (

                        <input
                            type="text"
                            inputMode="numeric"
                            className="form-control form-control-sm text-end"
                            value={valoresEditados.ingresos_reales}
                            onChange={(e) =>
                                setValoresEditados({
                                    ...valoresEditados,
                                    ingresos_reales: e.target.value.replace(/[^\d.]/g, "")
                                })
                            }
                        />

                        ) : (

                          formatoMoneda(item.ingresos_reales_mes)

                        )}

                      </td>
                      <td className="text-end">{formatoMoneda(item.ppto_ingresos_acum)}</td>
                      <td className="text-end">{formatoMoneda(item.esperado_ingresos_acum)}</td>
                      <td className="text-end">{formatoMoneda(item.ingresos_reales_acum)}</td>

                      {/* C&G */}

                      <td className="text-end">{formatoMoneda(item.ppto_cg_mes)}</td>
                      <td className="text-end">{formatoMoneda(item.esperado_cg_mes)}</td>
                      <td className="text-end">{editandoId === item.id ? (

                        <input
                            type="text"
                            inputMode="numeric"
                            className="form-control form-control-sm text-end"
                            value={valoresEditados.cg_mes}
                            onChange={(e) =>
                                setValoresEditados({
                                    ...valoresEditados,
                                    cg_mes: e.target.value.replace(/[^\d.]/g, "")
                                })
                            }
                        />

                        ) : (

                          formatoMoneda(item.cg_mes)

                        )}

                      </td>
                      <td className="text-end">{formatoMoneda(item.ppto_cg_acum)}</td>
                      <td className="text-end">{formatoMoneda(item.esperado_cg_acum)}</td>
                      <td className="text-end">{formatoMoneda(item.cg_acum)}</td>

                      {/* RESULTADO */}

                      <td className="text-end">{formatoMoneda(item.resultado_mes)}</td>
                      <td className="text-end">{formatoMoneda(item.resultado_acumulado)}</td>

                      {/* ADMINISTRACIÓN */}

                      <td className="text-end">{formatoMoneda(item.ppto_admon)}</td>
                      <td className="text-end">{formatoMoneda(item.esperado_admon)}</td>
                      <td className="text-end">{formatoMoneda(item.admon_mes)}</td>
                      <td className="text-end">{formatoMoneda(item.ppto_admon_acum)} </td>
                      <td className="text-end">{formatoMoneda(item.esperado_admon_acum)}</td>
                      <td className="text-end">{formatoMoneda(item.admon_acum)}</td>

                      {/* ACCIONES */}
                      <td className="text-center">{editandoId === item.id ? (

                          <div className="d-flex gap-2 justify-content-center">

                            <button
                              type="button"
                              className="btn btn-success btn-sm"
                              onClick={() => guardarEdicion(item.id)}
                              disabled={guardando}
                              title="Guardar"
                            >
                              {guardando ? (
                                <span className="spinner-border spinner-border-sm"></span>
                              ) : (
                                <i className="bi bi-check-lg"></i>
                              )}
                            </button>

                            <button
                              type="button"
                              className="btn btn-secondary btn-sm"
                              onClick={cancelarEdicion}
                              disabled={guardando}
                              title="Cancelar"
                            >
                              <i className="bi bi-x-lg"></i>
                            </button>

                          </div>

                        ) : (

                          <button
                            type="button"
                            className="btn btn-outline-pink btn-sm"
                            onClick={() => iniciarEdicion(item)}
                            title="Editar"
                          >
                            <i className="bi bi-pencil"></i>
                          </button>

                        )}

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          </div>

        </div>

      )}

    </div>

  );

};

export default SeguimientoFinanciero;